import React from 'react'

import compose from 'vegas-js-core/src/functors/compose'

import initApp from '../../contexts/app/initApp'

import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import WorkIcon from '@material-ui/icons/Work'

import PropertyValue from '../../things/PropertyValue'

import ThingChildren, { styles } from './ThingChildren'

import TechnicianCell from '../cells/TechnicianCell'

import Technician from '../../things/Technician'
import Thing      from '../../things/Thing'

class Technicians extends ThingChildren
{
    addMapUri = ( item , uri ) =>
    {
        if( item instanceof PropertyValue )
        {
            const { value } = item ;
            if( value instanceof Thing )
            {
                const { id } = value ;
                return uri + '/' + id ;
            }
        }
        return uri ;
    };

    addPrepare = item =>
    {
        const { value } = item ;
        return { value } ;
    }

    createChild = child => child instanceof Technician
                         ? <TechnicianCell thing={child} />
                         : null ;
    
    getLocale = () => this.props.locale.things.technicians ;
}

Technicians.defaultProps =
{
    ...ThingChildren.defaultProps ,
    animate    : true ,
    clazz      : Technician ,
    emptyClazz : PropertyValue ,
    emptyIcon  : null ,
    icon       : <WorkIcon/> ,
    member     : 'technicians'
};

Technicians.propTypes =
{
    ...ThingChildren.propTypes
};

export default compose( withStyles( styles ) , withRouter , initApp )( Technicians ) ;